var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"vast-service-order-now-overlay"},[_c('div',{class:[
      'vast-service-order-now-modal',
      {
        'vast-service-order-now-modal--large': _vm.large
      }
    ],style:(_vm.modalStyle)},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }